import React from 'react';
import { CustomAccordion, ExternalLink } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionAccordions = props => {
  const { description, metadataTags = [] } = props;
  const descriptionContent = description
    ? richText(description, {
        linkify: true,
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        longWordClass: css.longWord,
      })
    : 'No description available.';

  return (
    <div>
      {description && (
        <CustomAccordion title="Description" defaultOpen={true}>
          <div className={css.accordionContent}>
            {descriptionContent}
            {/*
            {metadataTags.length > 0 ? (
              <div className={css.metadataPills}>
                {metadataTags.map((tag, idx) => (
                  <span key={idx} className={css.metadataPill}>
                    {tag}
                  </span>
                ))}
              </div>
            ) : null}
            */}
          </div>
        </CustomAccordion>
      )}

      <CustomAccordion title="Shipping" defaultOpen={false}>
        <div className={css.accordionContent}>
          When you purchase this item, the seller will receive a prepaid shipping label and has 5
          business days to ship your order via USPS. Your payment will be held securely until
          delivery is confirmed, then released to the seller within 3 business days.
        </div>
      </CustomAccordion>

      <CustomAccordion title="International shipping" defaultOpen={false}>
        <div className={css.accordionContent}>
          We currently don&apos;t offer global shipping, but we hate to see anyone miss out on
          something they love. If there&apos;s an item you&apos;re eyeing and you&apos;re outside
          our usual delivery area, shoot us a message at{' '}
          <ExternalLink href={`mailto:hello@unvarnished.clothing`}>
            hello@unvarnished.clothing
          </ExternalLink>{' '}
          and we&apos;ll do our best to work something out. Can&apos;t promise miracles, but
          we&apos;re always up for finding creative solutions when we can.
        </div>
      </CustomAccordion>

      <CustomAccordion title="Returns" defaultOpen={false} className={css.accordionNoBorder}>
        <div className={css.accordionContent}>
          If your item doesn&apos;t fit as expected, you can leave an honest review and relist it
          with a reduced 10% commission instead of the standard 20%. If the item you receive is
          significantly different from what was described (wrong color, style, etc.), we&apos;ll
          cancel the order and provide a prepaid return label to send it back to the seller.
        </div>
      </CustomAccordion>
    </div>
  );
};

export default SectionAccordions;
